
import { Component, Vue } from 'vue-property-decorator'

import AllRallyRounds from '@/components/admin/AllRallyRounds.vue'

@Component({
  components: {
    AllRallyRounds
  }
})
export default class RallyRounds extends Vue {}
